import API from "../utils/api";

export const getIeOrderApi = async (data) => {
    const response = await API.get('order/get-all-ie-order', { params: data });
    return { response };
};

export const reCreateIEOrderApi = async (data) => {
    const response = await API.get('order/create-ie-order-manually/' + data);
    return { response };
};
